/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs */

const es_components_credentials_permissions_remove_toast_loading_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando permiso`)
};

const en_components_credentials_permissions_remove_toast_loading_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing permission`)
};

/**
* | output |
* | --- |
* | "Removing permission" |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_loading_title = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_loading_title(inputs)
	return en_components_credentials_permissions_remove_toast_loading_title(inputs)
});
export { components_credentials_permissions_remove_toast_loading_title as "components.credentials.permissions.remove.toast.loading.title" }